import React, { Component } from 'react';
import s from './AddItemForm.css';
import rs from '../../../../../components/storeCommon.css'
import { Field, reduxForm, getFormValues, change, formValueSelector } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import {
	Form,
	Col,
	Row,
	InputGroup,
	Container,
	Accordion,
	Card,
	Button,
	Badge
} from 'react-bootstrap';

import validate from './validate';
import submit from './submit';
import Loader from '../../../../Common/Loader';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from '../../../../../locale/messages';
import Dropzone from '../../../Dropzone';
import ItemImageDropzone from './ItemImageDropzone';
import { api, itemImageUploadDir } from '../../../../../config'
import { uploadPastedImage } from './pasteImageUpload';
import { getCurrencySymbol } from '../../../../../helpers/currencyConvertion';
import DefaultImage from '../../../../../../public/StoreIcon/store-profile-default.svg';
import { convert } from '../../../../../helpers/currencyConvertion'
// images
import EditIcon from '../../../../../../public/StoreIcon/edit.svg';
import TrashIcon from '../../../../../../public/StoreIcon/dlty.svg';
import downArrow from '../../../../../../public/StoreIcon/Dropdownwithcircle30x30.svg';
import upArrow from '../../../../../../public/StoreIcon/Uparrowwithcircle30x30.svg';
import PlusIcon from '../../../../../../public/StoreIcon/plusIcon.svg'
//components
import ConfirmationPopup from '../../../../Common/ConfirmationPopup';
import AddModifierModal from '../AddModifierModal/AddModifierModal';
import ModifierCommonType from '../ModifierCommonType/ModifierCommonType';
//actions
import deleteMenu from '../../../../../actions/shop/menu/deleteMenu';
import { openModal, closeModal, openItemModal, editItemModal } from '../../../../../actions/siteadmin/modalActions';
import getExistingModifier from '../../../../../actions/shop/modifier/getExistingModifier';
import getBookedModifierGroup from '../../../../../actions/shop/modifier/getBookedModifierGroup';
import history from '../../../../../history';
import { setLoaderStart, setLoaderComplete } from '../../../../../actions/loader/loader';

class AddItemForm extends React.Component {


	static defaultProps = {
		loading: false,
	};

	constructor(props) {
		super(props);
		this.state = {
			collapseID: [],
			modifierList: [],
		}
		this.handleDropzone = this.handleDropzone.bind(this);
		this.toggleCollapse = this.toggleCollapse.bind(this);
		this.handleStatus = this.handleStatus.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleModifierItem = this.handleModifierItem.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.loaderStart = this.loaderStart.bind(this);
		this.loaderEnd = this.loaderEnd.bind(this);
		this.handlePaste = this.handlePaste.bind(this);
	}

	componentDidMount() {
		const { modifiers } = this.props;
		if (modifiers) {
			this.setState({ modifierList: modifiers });
		}
		if (typeof window !== 'undefined') {
			window.addEventListener('paste', this.handlePaste);
		}
	}

	componentWillUnmount() {
		if (typeof window !== 'undefined') {
			window.removeEventListener('paste', this.handlePaste);
		}
	}

	componentWillMount() {
		const { base, rates, price, profile, change } = this.props;

		if (price) {
			let convertedAmount = convert(base, rates, price, profile && profile.preferredCurrency, profile && profile.preferredCurrency);
			convertedAmount = convertedAmount && convertedAmount.toString().includes('.')
				?
				convertedAmount.toFixed(2) : convertedAmount
			change('price', convertedAmount)
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { modifiers, change, id, stock, isStockEnabled } = nextProps;
		if (modifiers) {
			this.setState({ modifierList: modifiers });
		}

		// Initialize stock fields when editing an existing item
		if (id && (stock !== undefined || isStockEnabled !== undefined)) {
			if (isStockEnabled !== undefined && isStockEnabled !== this.props.isStockEnabled) {
				change('isStockEnabled', isStockEnabled);
			}
			if (stock !== undefined && stock !== this.props.stock) {
				change('stock', stock);
			}
		}
	}

	async handleDelete(id) {
		const { change, closeModal } = this.props;
		const { modifierList } = this.state;
		const modifierData = modifierList;
		modifierData.splice(id, 1);
		await closeModal('menuDeleteModal')
		change(`modifiers`, modifierData);
	};

	async handleStatus(index1, index2, status) {
		const { change } = this.props;
		await change(`modifiers[${index1}].modifierGroups[${index2}].isActive`, status);
	};

	toggleCollapse(id) {
		const { collapseID } = this.state;
		const index = collapseID.indexOf(id);
		if (index > -1) {
			collapseID.splice(index, 1);
			this.setState({ collapseID });
		} else {
			collapseID.push(id);
			this.setState({ collapseID });
		}
	}


	handleDropzone(fileName, fieldName) {
		const { change } = this.props
		change(fieldName, fileName)
	}

	async handlePaste(e) {
		const target = e.target;
		if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA')) {
			return;
		}

		const items = (e.clipboardData || e.originalEvent.clipboardData).items;
		let hasImage = false;
		if (items) {
			for (let i = 0; i < items.length; i++) {
				if (items[i].type.indexOf('image') !== -1) {
					hasImage = true;
					break;
				}
			}
		}

		if (!hasImage) return;

		const { change, setLoaderStart, setLoaderComplete } = this.props;
		setLoaderStart('itemImageLoader');
		try {
			const fileName = await uploadPastedImage(e, '/uploadItemImage');
			if (fileName) change('image', fileName);
		} catch (err) {
			console.error('[handlePaste]', err);
			const { toastr } = await import('react-redux-toastr');
			toastr.error('Upload Error', 'Failed to upload pasted image. Please try again.');
		} finally {
			setLoaderComplete('itemImageLoader');
		}
	}

	async handleModifierItem(index, modifierGroupId) {
		const { getBookedModifierGroup, openModal } = this.props;
		const { data } = await getBookedModifierGroup(modifierGroupId);
		if (data.length > 0) {
			openModal('menuDeleteModal', { id: index, checkBookedModifier: true });
		} else {
			openModal('menuDeleteModal', { id: index, checkBookedModifier: false });
		}
	};

	renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, maxlength }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group className={cx(rs.space5, 'positionRelative')}>
				<label className={'inputLabel'} for={input.name}>{label}</label>
				<Form.Control {...input} placeholder={placeholder} type={type} className={fieldClass} maxLength={maxlength} />
				{touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}

	renderBareField = ({ input, type, meta: { touched, error }, fieldClass, placeholder, disabled }) => {
		const { formatMessage } = this.props.intl;
		return (
			<div className={s.weightInputWrapper}>
				<Form.Control {...input} placeholder={placeholder} type={type} className={fieldClass} disabled={disabled} />
				{touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
			</div>
		)
	}

	renderTextAreaField = ({ input, label, type, meta: { touched, error }, children, labelClass, fieldClass, placeholder, maxLength }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group className={cx(rs.space5, 'positionRelative')}>
				<label className={'inputLabel'} for={input.name}>{label}</label>
				<Form.Control as="textarea"  {...input} placeholder={placeholder} type={type} className={cx(fieldClass, rs.textAreaField)} maxLength={maxLength} />
				{touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}

	renderPrice = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, prefix, prefixLabel }) => {
		const { profile, currentLocale } = this.props;
		const { formatMessage } = this.props.intl;
		return (
			<div className={'retaurantInputFormAddon'}>
				<Form.Group className={cx(rs.space5, 'positionRelative')}>
					{prefix && <label htmlFor={input.name} className={cx('inputLabel', 'accordionLabel')}>{label}</label>}
					{!prefix && <label htmlFor={input.name} className={'inputLabel'}>{label}</label>}
					<InputGroup>
						{prefix && <InputGroup.Append>
							<InputGroup.Text>{getCurrencySymbol(profile && profile.preferredCurrency, currentLocale)}</InputGroup.Text>
						</InputGroup.Append>}
						<Form.Control {...input} placeholder={placeholder} type={type} className={fieldClass} />
						{!prefix && <InputGroup.Append>
							<InputGroup.Text>{prefixLabel}</InputGroup.Text>
						</InputGroup.Append>}
					</InputGroup>
					{touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
				</Form.Group>
			</div>
		)
	}


	renderSelectField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, children }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group className={cx(rs.space5, 'positionRelative', 'store')}>
				<label for={input.name} className={'inputLabel'}>{label}</label>
				<Form.Control as="select" {...input} placeholder={placeholder} className={fieldClass}>
					{children}
				</Form.Control>
				{touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}

	handleCancel() {
		const { menuId } = this.props;
		history.push(`/store/menu/${menuId}/item`);
	}

	async loaderStart() {
		const { setLoaderStart } = this.props;
		setLoaderStart('itemImageLoader')
	}

	async loaderEnd() {
		const { setLoaderComplete } = this.props;
		setLoaderComplete('itemImageLoader')
	}


	render() {
		const { error, handleSubmit, submitting, dispatch, loading, id, image, menuId, subMenuId, imageLoader } = this.props;
		const { formatMessage } = this.props.intl;
		const { openModal, closeModal, menuDeleteModal, openItemModal, getExistingModifier, modifierGroupId, editItemModal, modalData, isEnableAddon } = this.props;
		const { collapseID, modifierList } = this.state;

		// if (this.props.profile) {
		// 	console.log('AddItemForm deliveryType:', this.props.profile.deliveryType);
		// }

		return (
			<div className="mainContainer">
				<AddModifierModal from={"item"} />

				<ConfirmationPopup
					modalStatus={menuDeleteModal}
					checkBookedModifier={modalData && modalData.checkBookedModifier}
					title={formatMessage(messages.deleteModifier)}
					body={formatMessage(messages.deleteConfirmation)}
					bodyModifier={formatMessage(messages.deleteConfirmationModifier)}
					closeModal={() => closeModal('menuDeleteModal')}
					popupButtonLeftName={formatMessage(messages.cancelButton)}
					popupButtonRightName={formatMessage(messages.deleteAction)}
					popupButtonLeftFunction={() => closeModal('menuDeleteModal')}
					popupButtonRightFunction={() => this.handleDelete(modalData.id)}
				/>

				<div className={cx(rs.space5, s.responsiveNoPadding)}>
					<Container fluid>
						<h1 className={cx(rs.storeTitleText, 'textAlignRightRTL')}>
							<FormattedMessage {...messages.itemSettings} />
						</h1>
						<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
							<div className={cx(rs.storeNewBg, rs.space5)}>
								<Row>

									<Col lg={12} md={12} sm={12} xs={12} className={rs.spaceTop1}>
										<div>
											<Row>
												<Col xl={6} lg={12} md={12} sm={12} xs={12}>
													<Field
														name="itemName"
														type="text"
														placeholder={formatMessage(messages.itemName)}
														component={this.renderField}
														labelClass={s.labelText}
														fieldClass={cx(rs.formControlInputStore, 'formControlInputStoreRTL')}
														label={formatMessage(messages.itemName)}
														maxLength={100}
													/>
													<Field
														name="itemDescription"
														type="text"
														placeholder={formatMessage(messages.itemDescription)}
														component={this.renderTextAreaField}
														labelClass={s.labelText}
														fieldClass={cx(rs.formControlInputStore, 'formControlInputStoreRTL')}
														label={formatMessage(messages.itemDescription)}
														maxLength={250}
													/>
												</Col>
												<Col xl={6} lg={12} md={12} sm={12} xs={12}>
													<Form.Group className={cx(s.space2, 'positionRelative')}>
														<label className={'inputLabel'} htmlFor="itemImage">{formatMessage(messages.itemImage)}</label>
														<ItemImageDropzone
															imageUrl={image ? api.apiEndpoint + itemImageUploadDir + image : null}
															onUploadStart={this.loaderStart}
															onUploadEnd={this.loaderEnd}
															onSuccess={(fileName) => this.handleDropzone(fileName, 'image')}
														/>
													</Form.Group>
												</Col>

												<Col lg={6} md={12} sm={12} xs={12}>
													<Field
														name="price"
														type="text"
														placeholder={formatMessage(messages.price)}
														component={this.renderPrice}
														labelClass={s.labelText}
														fieldClass={cx(rs.formControlInputStore, 'formControlInputStoreRTL')}
														prefix={true}
														label={formatMessage(messages.price)}
													/>
												</Col>
												{this.props.profile && this.props.profile.deliveryType === 2 &&
													<Col lg={6} md={12} sm={12} xs={12}>
														<Field
															name="tax"
															type="text"
															placeholder={formatMessage(messages.tax)}
															component={this.renderPrice}
															labelClass={s.labelText}
															fieldClass={cx(rs.formControlInputStore, s.taxBorder, 'formControlInputStoreRTL')}
															prefixLabel={formatMessage(messages.percent)}
															prefix={false}
															label={formatMessage(messages.tax)}
														/>
													</Col>
												}

												{this.props.profile && this.props.profile.deliveryType === 3 &&
													<Col lg={6} md={12} sm={12} xs={12}>
														<div className={s.weightRoot}>
															<label className={'inputLabel'} for="discountValue">{formatMessage(messages.discountItem)}</label>
															<div className={s.child}>
																<Field
																	name="discountValue"
																	type="number"
																	component={this.renderBareField}
																	placeholder={formatMessage(messages.discountItem)}
																	fieldClass={cx(rs.formControlInputStore, s.noMargin, s.weightInput)}
																	label=""
																/>
																<Field name="discountType" component="select" className={cx(s.formControlSelect, s.noMargin)}>
																	<option value="percentage">%</option>
																	<option value="fixed">fixed</option>
																</Field>
															</div>
														</div>
													</Col>
												}

												{this.props.profile && this.props.profile.deliveryType === 3 &&
													<Col lg={6} md={12} sm={12} xs={12}>
														<div className={s.weightRoot}>
															<label className={'inputLabel'} for="originalWeight">{formatMessage(messages.weight)}</label>
															<div className={s.child}>
																<Field
																	name="originalWeight"
																	type="number"
																	component={this.renderBareField}
																	placeholder={formatMessage(messages.weight)}
																	fieldClass={cx(rs.formControlInputStore, s.noMargin, s.weightInput)}
																	label=""
																/>
																<Field name="weightUnit" component="select" className={cx(s.formControlSelect, s.noMargin)}>
																	<option value="gr">gr</option>
																	<option value="kg">kg</option>
																	<option value="ml">ml</option>
																	<option value="l">l</option>
																</Field>
															</div>
														</div>
													</Col>
												}

												{this.props.profile && this.props.profile.deliveryType === 2 &&
													<Col lg={6} md={12} sm={12} xs={12}>
														<Field name="itemType"
															component={this.renderSelectField}
															fieldClass={cx(rs.formControlInputStore, 'formControlInputStoreRTL')}
															label={formatMessage(messages.itemType)}
														>
															<option value={0}>{formatMessage(messages.selectType)}</option>
															<option value={1}>{formatMessage(messages.itemType1)}</option>
															<option value={2}>{formatMessage(messages.itemType2)}</option>
															<option value={3}>{formatMessage(messages.itemType3)}</option>
														</Field>
													</Col>
												}
												<Col lg={6} md={12} sm={12} xs={12}>
													<Field name="isEnable" component={this.renderSelectField} label={formatMessage(messages.status)} fieldClass={cx(rs.formControlInputStore, s.customSelect)}>
														<option value={true}>{formatMessage(messages.active)}</option>
														<option value={false}>{formatMessage(messages.inactive)}</option>
													</Field>
												</Col>

												{this.props.profile && this.props.profile.deliveryType === 3 && (
													<Col lg={6} md={12} sm={12} xs={12}>
														<Form.Group className={cx(rs.space5, 'positionRelative')}>
															<label className={'inputLabel'} for="stock">Stock</label>
															<div className={s.weightRoot}>
																<div className={s.child}>
																	<Field
																		name="stock"
																		type="number"
																		component={this.renderBareField}
																		placeholder={'Stock'}
																		fieldClass={cx(rs.formControlInputStore, s.noMargin, s.weightInput)}
																		disabled={!(this.props.isStockEnabled === true || this.props.isStockEnabled === 'true')}
																	/>
																	<Field name="isStockEnabled" component="select" className={cx(s.formControlSelect, s.noMargin)}>
																		<option value={true}>Enable</option>
																		<option value={false}>Disable</option>
																	</Field>
																</div>
															</div>
														</Form.Group>
													</Col>
												)}

												{this.props.profile && this.props.profile.deliveryType === 3 && (
													<Col lg={6} md={12} sm={12} xs={12}>
														<Field
															name="sku"
															type="text"
															placeholder={formatMessage(messages.sku)}
															component={this.renderField}
															labelClass={s.labelText}
															fieldClass={cx(rs.formControlInputStore, 'formControlInputStoreRTL')}
															label={formatMessage(messages.sku)}
														/>
													</Col>
												)}
												{this.props.profile && this.props.profile.deliveryType === 3 && (
													<Col lg={6} md={12} sm={12} xs={12}>
														<Field
															name="upc"
															type="text"
															placeholder={formatMessage(messages.upc)}
															component={this.renderField}
															labelClass={s.labelText}
															fieldClass={cx(rs.formControlInputStore, 'formControlInputStoreRTL')}
															label={formatMessage(messages.upc)}
														/>
													</Col>
												)}
											</Row>
										</div>
									</Col>
								</Row>
								{Number(isEnableAddon) === 1 && this.props.profile.deliveryType === 2 && < Row>
									<div className={s.borderCss}>
										<Col lg={12} md={12} sm={12} xs={12}>
											<hr className={s.hrLine} />
										</Col>
										<Col lg={12} md={12} sm={12} xs={12}>
											{/* <div className={cx(rs.searchInputStore)}> */}
											<Row className={s.alignCenter}>
												<Col lg={6} md={12} sm={12} xs={12} className={'positionRelative'}>
													<label htmlFor="modifierGroupId" className={cx('inputLabel', s.modifierLabel, 'accordionLabel', 'modifierLabelRTL')}>{formatMessage(messages.addModifierGroup)}</label>
													<ModifierCommonType
													/>
												</Col>
												{/* <div className={cx(s.displayInlineBlock, rs.searchTopBtn, s.searchTopBtnMob)}> */}
												<Col lg={6} md={12} sm={12} xs={12} className={s.motifierBtn}>
													<Button className={cx(rs.button, rs.btnPrimary, s.displayInlineBlock)} onClick={() => openItemModal(menuId, subMenuId)}>
														<img alt="icon" src={PlusIcon} className={cx(rs.storeCommonPlusIcon, 'iconWidthRTL')} />
														<FormattedMessage {...messages.newModifierGroups} />
													</Button>
												</Col>
											</Row>
											{
												modifierList && modifierList.length > 0 && modifierList.map((data, index1) => {
													return (

														data && data.modifierGroups.length > 0 && data.modifierGroups.map((item, index2) => {
															return (
																<div className='modifierAcccordion'>
																	<Accordion defaultActiveKey="0">
																		<Card>
																			<Card.Header>
																				<div className={s.menuItemGrid}>
																					<div className={s.menuFirstSection}>
																						<div className={cx(rs.alignLeft, rs.tabSection, s.paddingLeft)}>
																							<p className={cx(rs.idTitle, rs.textOverFlow, s.idTitleText)}>
																								{item.modifierName}

																							</p>
																							{
																								item.modifierCommonId && <Badge className={s.badge}>{formatMessage(messages.common)}</Badge>
																							}
																							{
																								!item.modifierCommonId && <Badge className={s.badge}>{formatMessage(messages.individual)}</Badge>
																							}
																						</div>
																						<div className={cx('storeActiveSelect', s.inactiveColor)}>
																							{!item.modifierCommonId && <select value={item.isActive} onChange={(e) => { this.handleStatus(index1, index2, e.target.value) }} className={cx(rs.activeSelect, rs.storeSelectInput)}>
																								<option value={"true"}>{formatMessage(messages.active)}</option>
																								<option value={"false"}>{formatMessage(messages.inactive)}</option>
																							</select>}
																							{item.modifierCommonId && item.isActive === "false" && formatMessage(messages.inactive)}
																						</div>
																						<div className={rs.editCenterBtn}>
																							<Button className={cx(rs.linkColor, s.displayInlineBlock)} onClick={() => editItemModal('ModifierGroupForm', index1, index2)}>
																								<img src={EditIcon} className={s.iconsWidth} alt='edit icon' />
																								<span className={cx(s.vtrMiddle, s.editSection)}>{formatMessage(messages.editItem)}</span>
																							</Button>
																						</div>
																						<div className={rs.editCenterBtn}>
																							<Button className={cx(rs.deleteBtn, s.editBtn, s.IconLeft, rs.textOverFlow)} onClick={() => this.handleModifierItem(index1, item.id)}>
																								<img src={TrashIcon} className={s.iconsWidth} alt='trash icon' />
																								<span className={s.vtrMiddle}>{formatMessage(messages.deleteAction)}</span>
																							</Button>

																						</div>
																					</div>
																				</div>
																				<Accordion.Toggle variant="link" eventKey="1" className={'arrowBtn'} onClick={() => this.toggleCollapse(item.id)}>
																					<img src={collapseID.includes(item.id) ? upArrow : downArrow} width={'30px'} height={'30px'} alt='arrow icon' />
																				</Accordion.Toggle>
																			</Card.Header>
																			<Accordion.Collapse eventKey="1">
																				<Card.Body>
																					{
																						item.modifierItems && item.modifierItems.length > 0 && <span>{formatMessage(messages.item)}: </span>
																					}
																					{
																						item.modifierItems && item.modifierItems.length > 0 && item.modifierItems.map(function (elem) {
																							return elem.modifierItemName;
																						}).join(", ")
																					}
																				</Card.Body>
																			</Accordion.Collapse>
																		</Card>
																	</Accordion>
																</div>
															)
														})
													)
												})
											}
										</Col>
									</div>
								</Row>}
							</div>
							<Row>
								<Col lg={12} md={12} sm={12} xs={12} className={cx(rs.alignRightText)}>
									<Form.Group className={cx(s.padding2, s.rightSide)}>
										<div className={rs.secondryBtnSection}>
											<button type='button' onClick={this.handleCancel} className={cx(rs.button, rs.btnPrimaryBorder, rs.displayBlock)}>
												<FormattedMessage {...messages.cancel} />
											</button>
										</div>
										<div className={cx(rs.secondryBtnSection, 'rtlLoader')}>
											<Loader
												type={"button"}
												label={id ? formatMessage(messages.update) : formatMessage(messages.save)}
												show={loading}
												buttonType={'submit'}
												className={cx(rs.button, rs.btnPrimary, rs.btnFullWidth)}
												disabled={submitting || loading}
												isSuffix={true}
											/>
										</div>
									</Form.Group>
								</Col>
							</Row>
						</Form>
					</Container>
				</div>
			</div >
		)
	}

}

const AddItemFormRedux = reduxForm({
	form: 'AddItemForm',
	onSubmit: submit,
	validate,
	enableReinitialize: false
})(AddItemForm);

const selector = formValueSelector('AddItemForm');


const mapState = (state) => ({
	loading: state.loader.CommonSettings,
	image: selector(state, 'image'),
	id: selector(state, 'id'),
	price: selector(state, 'price'),
	menuId: selector(state, 'menuId'),
	originalWeight: selector(state, 'originalWeight'),
	weightUnit: selector(state, 'weightUnit'),
	discountType: selector(state, 'discountType'),
	discountValue: selector(state, 'discountValue'),
	isStockEnabled: selector(state, 'isStockEnabled'),
	stock: selector(state, 'stock'),
	subMenuId: selector(state, 'subMenuId'),
	modifierGroupId: selector(state, 'modifierGroupId'),
	modifiers: selector(state, 'modifiers'),
	profile: state.account?.data?.profile,
	currentLocale: state.intl.locale,
	base: state.currency.base,
	rates: state.currency.rates,
	menuDeleteModal: state.modalStatus.menuDeleteModal,
	modalData: state.modalStatus.data && state.modalStatus.data[0],
	isEnableAddon: state.siteSettings.data.modifiers,
	imageLoader: state.loader.itemImageLoader,
});

const mapDispatch = {
	change,
	deleteMenu,
	openModal,
	closeModal,
	openItemModal,
	getExistingModifier,
	editItemModal,
	getBookedModifierGroup,
	setLoaderStart,
	setLoaderComplete,
};

export default injectIntl(withStyles(s, rs)(connect(mapState, mapDispatch)(AddItemFormRedux)));